<form [formGroup]="form">
  <div class="flex flex-col gap-6 px-4">
    <h2 class="filter-title text-[18px] font-semibold" i18n="@@adminRejectionReasonEdit">Edit Rejection Reason</h2>
    <div class="edit-rejection-card mt-2 rounded-[8px] border px-6 py-6 shadow-sm">
      <div class="grid grid-cols-2 items-start gap-6">
        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-semibold text-gray-700">
            {{ reasonArabicLabel }}
            <span class="required">*</span>
          </label>
          <app-filter-input
            label=""
            [placeholder]="reasonARPlaceholder"
            [value]="form.controls.reasonAR.value"
            (valueChange)="onArabicValueChange($event)"
            [isInvalid]="showValidationErrors() && form.controls.reasonAR.invalid"></app-filter-input>
          @if (showValidationErrors() && form.controls.reasonAR.errors) {
            <p class="text-sm text-red-600">
              @if (form.controls.reasonAR.hasError("required")) {
                {{ rejectionReasonArabicRequired }}
              } @else if (form.controls.reasonAR.hasError("minlength")) {
                {{ rejectionReasonMinLength }}
              } @else if (form.controls.reasonAR.hasError("maxlength")) {
                {{ rejectionReasonMaxLength }}
              } @else if (form.controls.reasonAR.hasError("leadingOrTrailingSpaces")) {
                {{ rejectionReasonArabicSpaces }}
              } @else if (form.controls.reasonAR.hasError("numbersNotAllowed")) {
                {{ rejectionReasonNumbersNotAllowed }}
              } @else if (form.controls.reasonAR.hasError("invalidArabicCharacters")) {
                {{ rejectionReasonArabicCharacters }}
              }
            </p>
          }
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-semibold text-gray-700">
            {{ reasonEnglishLabel }}
          </label>
          <app-filter-input
            label=""
            [placeholder]="reasonENPlaceholder"
            [value]="form.controls.reasonEN.value"
            (valueChange)="onEnglishValueChange($event)"
            [isInvalid]="showValidationErrors() && form.controls.reasonEN.invalid"></app-filter-input>
          @if (showValidationErrors() && form.controls.reasonEN.errors) {
            <p class="text-sm text-red-600">
              @if (form.controls.reasonEN.hasError("minlength")) {
                {{ rejectionReasonMinLength }}
              } @else if (form.controls.reasonEN.hasError("maxlength")) {
                {{ rejectionReasonMaxLength }}
              } @else if (form.controls.reasonEN.hasError("leadingOrTrailingSpaces")) {
                {{ rejectionReasonEnglishSpaces }}
              } @else if (form.controls.reasonEN.hasError("numbersNotAllowed")) {
                {{ rejectionReasonNumbersNotAllowed }}
              } @else if (form.controls.reasonEN.hasError("invalidEnglishCharacters")) {
                {{ rejectionReasonEnglishCharacters }}
              }
            </p>
          }
        </div>
      </div>
      <div class="mt-6 flex justify-end gap-3">
        <div (click)="goBack()">
          <app-submit-button type="secondary">
            <span i18n="@@adminProductsDeleteCancel">Cancel</span>
          </app-submit-button>
        </div>
        <div (click)="onSubmit()">
          <app-submit-button type="primary">
            <span i18n="@@adminCategoriesSubmitButton">Submit</span>
          </app-submit-button>
        </div>
      </div>
    </div>
  </div>
  @if (showConfirmation()) {
    <app-confirmation-dialog
      [layout]="'start'"
      [title]="confirmEditReasonTitle"
      [description]="confirmEditReasonDescription"
      [confirmContent]="confirmButton()"
      [cancelContent]="cancelButton"
      (onCancel)="closeConfirmation()"
      (onSubmit)="onConfirmEdit()"
      [error]="editReasonError()"></app-confirmation-dialog>
  }
  @if (showEditSuccess()) {
    <app-successful-notification type="success" [title]="successEditTitle()" />
  }
</form>
